import { render, staticRenderFns } from "./SolutionDetails.vue?vue&type=template&id=77a5e472&scoped=true&"
import script from "./SolutionDetails.vue?vue&type=script&lang=js&"
export * from "./SolutionDetails.vue?vue&type=script&lang=js&"
import style0 from "./SolutionDetails.vue?vue&type=style&index=0&id=77a5e472&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a5e472",
  null
  
)

export default component.exports